import { footerSettingsAtom } from "./atoms";
import { useAtom } from "jotai";

export function useFooterSettings() {
  const [{ data, error, isLoading }] = useAtom(footerSettingsAtom);
  return {
    footerSettings: data,
    error,
    isLoading,
  };
}
